
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iit-news",
      function () {
        return require("private-next-pages/iit-news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iit-news"])
      });
    }
  